module.exports = __webpack_public_path__ + "static/img/envelope01thai.812d11a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope01thai.png
// module id = NevM
// module chunks = 1